var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPaperPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 31.94 31.94"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19378",
  transform: "translate(-310.06 -541.353)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 15.97,
  cy: 15.97,
  r: 15.97,
  "data-name": "Ellipse 1407",
  transform: "translate(310.06 541.353)"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.369,
  "data-name": "Group 12538"
}, /*#__PURE__*/React.createElement("path", {
  d: "m318.203 555.969 12.488-5.7a1.4 1.4 0 0 1 1.873 1.812l-5.385 12.915a1.4 1.4 0 0 1-2.488.189l-2.371-3.9a1.4 1.4 0 0 0-.453-.458l-3.826-2.4a1.4 1.4 0 0 1 .162-2.458Z",
  "data-name": "Path 6103"
}), /*#__PURE__*/React.createElement("path", {
  d: "m321.839 560.888 10.376-10.376",
  "data-name": "Line 785"
})))));
export { SvgPaperPlane as ReactComponent };
export default __webpack_public_path__ + "static/media/paper_plane.97f19d4c545fc38fb2be6cc75d6635e1.svg";